import React from "react";
import { useFormContext } from "react-hook-form";

import { Button } from "components";
import { FormTitle, LineDivider } from "components/layout";

import { SecondarySplitInformationFields } from "../secondarySplitInformationFields";

import styles from "../../splitProfile.module.scss";

type OverrideSecondarySplitInformationProps = {
	name: string;
	title: string;
	index: number;
	isLoading: boolean;
	splitInfo: { [key: string]: any };
	onRemoveSplitInfo: Function;
	setToggleAgentSelect: Function;
	toggleAgentSelect: boolean;
	isEditing: boolean;
};

export const OverrideSecondarySplitInformation = ({
	name,
	title,
	index,
	isLoading = false,
	splitInfo,
	onRemoveSplitInfo,
	setToggleAgentSelect,
	toggleAgentSelect,
}: OverrideSecondarySplitInformationProps) => {
	const { watch } = useFormContext();
	const secondarySplitInformation = watch("secondarySplitInformation");

	return (
		<React.Fragment>
			<LineDivider className="m-0" />
			<FormTitle>
				<h3>
					{title}
					<Button
						value="Remove Secondary Split Information"
						onClick={() => onRemoveSplitInfo?.(index)}
						variant="secondary"
						className={styles.removeBtn}
						disabled={
							index === 0 && secondarySplitInformation.length <= 1
						}
					/>
				</h3>
			</FormTitle>
			<SecondarySplitInformationFields
				name={name}
				splitInfo={splitInfo}
				isLoading={isLoading}
				setToggleAgentSelect={setToggleAgentSelect}
				toggleAgentSelect={toggleAgentSelect}
			/>
		</React.Fragment>
	);
};
